import { AMPLITUDE_PREFIX, ServerZone } from '@amplitude/analytics-core';
export var DEFAULT_EVENT_PROPERTY_PREFIX = '[Amplitude]';
export var DEFAULT_SESSION_REPLAY_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay ID");
export var DEFAULT_SESSION_START_EVENT = 'session_start';
export var DEFAULT_SESSION_END_EVENT = 'session_end';
export var DEFAULT_SAMPLE_RATE = 0;
export var DEFAULT_SERVER_ZONE = ServerZone.US;
export var DEFAULT_PERFORMANCE_CONFIG = { enabled: true };
export var DEFAULT_URL_CHANGE_POLLING_INTERVAL = 1000;
export var SESSION_REPLAY_DEBUG_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay Debug");
export var BLOCK_CLASS = 'amp-block';
export var MASK_TEXT_CLASS = 'amp-mask';
export var UNMASK_TEXT_CLASS = 'amp-unmask';
export var SESSION_REPLAY_SERVER_URL = 'https://api-sr.amplitude.com/sessions/v2/track';
export var SESSION_REPLAY_EU_URL = 'https://api-sr.eu.amplitude.com/sessions/v2/track';
export var SESSION_REPLAY_STAGING_URL = 'https://api-sr.stag2.amplitude.com/sessions/v2/track';
export var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_replay_unsent");
export var MAX_EVENT_LIST_SIZE = 1 * 1000000; // ~1 MB limit for JSON serialized events payload
export var INTERACTION_MIN_INTERVAL = 30000; // 30 seconds
export var INTERACTION_MAX_INTERVAL = 60000; // 1 minute
export var MIN_INTERVAL = 500; // 500 ms
export var MAX_INTERVAL = 10 * 1000; // 10 seconds
export var MAX_IDB_STORAGE_LENGTH = 1000 * 60 * 60 * 24 * 3; // 3 days
export var KB_SIZE = 1024;
export var MAX_URL_LENGTH = 1000;
export var RETRY_TIMEOUT_MS = 1000;
export var CustomRRwebEvent;
(function (CustomRRwebEvent) {
    CustomRRwebEvent["GET_SR_PROPS"] = "get-sr-props";
    CustomRRwebEvent["DEBUG_INFO"] = "debug-info";
    CustomRRwebEvent["FETCH_REQUEST"] = "fetch-request";
    CustomRRwebEvent["METADATA"] = "metadata";
    CustomRRwebEvent["TARGETING_DECISION"] = "targeting-decision";
})(CustomRRwebEvent || (CustomRRwebEvent = {}));
//# sourceMappingURL=constants.js.map